var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.971,
    height: 48,
    viewBox: "0 0 47.971 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.146,
    y1: 0.146,
    x2: 0.986,
    y2: 0.986,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842bd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1.073,
    x2: 0.5,
    y2: 0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#842bd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ff007e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#ff474b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#ff8023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963,
    stopColor: "#ffa30a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zixxar-x-logo",
    transform: "translate(-400.4 -406.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79389",
    "data-name": "Path 79389",
    d: "M448.371,427.9V414.044l-7.053-7.054-.336.336,6.914,6.915V427.7l-6.584,6.572-6.848-6.848-.336.336,6.848,6.848-12.96,12.972-6.947-6.959-.336.335,6.947,6.96-6.59,6.6H407.65l-6.914-6.938-.336.335,7.053,7.078h13.835l6.728-6.735,6.723,6.735h13.632V441.333l-6.723-6.723ZM447.9,441.53v12.985H434.936l-6.584-6.6,12.96-12.973ZM407.552,427.8l-7.152-7.152.336-.336,6.816,6.816,12.983-12.984-6.839-6.817.335-.336,7.176,7.152Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79390",
    "data-name": "Path 79390",
    d: "M441.317,420.656l-27.286,27.265H400.4V434.289L427.686,407h13.631v13.656Zm-40.918,0L414.031,407H400.4v13.656Zm40.918,13.633-13.631,13.633h13.631V434.289Z",
    transform: "translate(0 -0.01)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18989",
    "data-name": "Group 18989",
    transform: "translate(408.29 415.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79391",
    "data-name": "Path 79391",
    d: "M764.2,1755.308l-.112-7.722-3.663,3.663-.679-.679,5.05-5.05.679.679.112,7.722,3.947-3.947.679.679-5.334,5.334Z",
    transform: "translate(-759.75 -1724.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79392",
    "data-name": "Path 79392",
    d: "M1031.84,1659.046l1-1,.8.8-1,1Zm1.439,1.439,1-1,3.837,3.837-1,1Z",
    transform: "translate(-1025.865 -1638.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79393",
    "data-name": "Path 79393",
    d: "M1104.39,1364.754l3.625.211-.212-3.625,1.28-1.28.291,4.985,4.985.291-1.28,1.28-3.625-.211.211,3.625-1.28,1.28-.291-4.985-4.985-.291Z",
    transform: "translate(-1095.571 -1347.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79394",
    "data-name": "Path 79394",
    d: "M1389.43,1079.714l3.625.211-.211-3.625,1.28-1.28.291,4.985,4.985.291-1.28,1.28-3.625-.212.212,3.625-1.28,1.28-.291-4.985-4.985-.291Z",
    transform: "translate(-1374.352 -1068.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79395",
    "data-name": "Path 79395",
    d: "M1766.7,954.755c-.919-.919-.208-1.63.5-2.342l1.707-1.707-.6-.6c-.24-.24-.418-.062-.6.116l-2.489,2.489-.6-.6,2.418-2.418c.711-.711,1.422-1.422,2.342-.5l2.918,2.918-2.7,2.7c-.711.711-1.422,1.422-2.342.5Zm2.231-.472,1.778-1.778-1.2-1.2-1.778,1.778c-.178.178-.355.355-.116.6l.719.719C1768.578,954.638,1768.756,954.46,1768.934,954.283Z",
    transform: "translate(-1742.565 -945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79396",
    "data-name": "Path 79396",
    d: "M2000.831,781.107c-.919-.919-.208-1.63.5-2.342l1-1,.6.6-1.067,1.067c-.178.178-.356.356-.116.6l3,3-1,1Z",
    transform: "translate(-1973.153 -777.77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterLogo);
export default __webpack_public_path__ + "static/media/register-logo.2c9f81fcb59ef6cca3dbfe5a1e8ffc84.svg";
export { ForwardRef as ReactComponent };